import { Controller } from "@hotwired/stimulus"

// Opens/closes the Force-fulfill dialog and toggles the note input's
// required state when "Other" is the chosen reason.
//
// Targets:
//   dialog      - the <dialog> element
//   otherRadio  - the "Other" reason radio (we flip note's required state on it)
//   noteInput   - the note textarea
export default class extends Controller {
    static targets = ["dialog", "otherRadio", "noteInput"]

    connect() {
        this._syncNoteRequired = this._syncNoteRequired.bind(this)
        this.element.addEventListener("change", this._syncNoteRequired)
        this._syncNoteRequired()
    }

    disconnect() {
        this.element.removeEventListener("change", this._syncNoteRequired)
    }

    open() {
        if (this.hasDialogTarget && this.dialogTarget.showModal) {
            this.dialogTarget.showModal()
        }
    }

    close() {
        if (this.hasDialogTarget) this.dialogTarget.close()
    }

    _syncNoteRequired() {
        if (!this.hasOtherRadioTarget || !this.hasNoteInputTarget) return
        this.noteInputTarget.required = this.otherRadioTarget.checked
    }
}
